// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { TooltipFragmentDoc } from '../../../directives/tooltip/tooltip.generated';
import { ContentComponentItemFragmentDoc } from '../../cms/component/ContentComponentItem.fragment.generated';
import { ComponentTitleFragmentDoc } from '../../cms/component/content/ContentTitle.fragment.generated';
import { ComponentTitleComponentFragmentDoc } from '../../cms/component/content/componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from '../../cms/component/content/componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from '../../cms/component/content/componentTitleText.fragment.generated';
import { ComponentTextFragmentDoc } from '../../cms/component/content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from '../../cms/component/content/ContentButton.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../cms/index.generated';
import { ComponentSpacerFragmentDoc } from '../../cms/component/content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from '../../cms/component/content/ContentImage.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../cms/cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../cms/imageSize.fragment.generated';
import { ComponentOrderedListFragmentDoc } from '../../cms/component/content/ContentOrderedList.fragment.generated';
import { OrderedListItemFragmentDoc } from '../../cms/component/content/orderedListItem.generated';
export const PageTooltipFragmentDoc = `
    fragment pageTooltip on PageTooltip {
  triggerText
  tooltip {
    ...tooltip
  }
}
    `;